<template>
    <Head>
        <title>{{ pageData.props.page.title }}</title>
    </Head>
    <div class="student_login_wrap">
        <div class="container container_center">
            <p class="sub_title" v-html="$t('pages.home.title')"></p>
            <div class="module_title">
                <h3>{{ $t('brand') }}</h3>
            </div>
            <div class="login_btns">
                <a href="javascript:;" @click="goTeacherPage">
                    <i class="fa-solid fa-chalkboard"></i>
                    <span>{{ $t('pages.home.buttons.teacher') }}</span>
                </a>
                <a href="javascript:;" @click="goStudentPage">
                    <i class="fa-solid fa-pencil"></i>
                    <span>{{ $t('pages.home.buttons.student') }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { Head, usePage } from '@inertiajs/vue3';
    import { goTeacherPage, goStudentPage } from '@/app/helpers/routerHelper';
    import { PageProps } from '@/teacher/types';

    const pageData = usePage<PageProps>();
</script>
